import React from 'react';
export function AnnouncementBar() {
  // Shipping and returns are part of the always-on promise line below.
  return <div className="w-full bg-grit-500 text-ink-950" data-id="element-9" data-mp="om4ug7boynkf">
      <p className="mx-auto max-w-[1400px] px-4 py-2 text-center text-[11px] font-bold uppercase leading-tight tracking-[0.12em] sm:text-xs sm:tracking-[0.18em]" data-id="element-10" data-mp="ju3lovdqfez5">
        Free U.S. shipping on multi-packs
        <span className="mx-2 hidden sm:inline" data-id="element-11" data-mp="9vnvcumj49qp">•</span>
        <span className="block sm:inline" data-id="element-12" data-mp="9x8p4i10roni">3 lenses included</span>
        <span className="mx-2 hidden sm:inline" data-id="element-13" data-mp="5u2j9bhtjzhk">•</span>
        <span className="mt-1 block sm:mt-0 sm:inline" data-id="element-14" data-mp="5wor7c8mgh0b">
          <span className="gold-plate inline-block px-2 py-0.5 tracking-[0.14em] text-ink-950 shadow-[0_6px_18px_-10px_rgba(212,160,23,0.9)]" data-id="element-15" data-mp="w0qfyulclsw">
            Lifetime free replacement
          </span>
        </span>
      </p>
    </div>;
}